module.exports = __webpack_public_path__ + "static/media/splash-primary-banner.fce5e7c7.png";